const GreffierMandataireStyle = {
  bg: "white",
  mt: 4,
};

const GreffierCommentsStyle = {
  flexWrap: "wrap",
  mt: "6",
  overFlow: "hidden",
  position: "relative",
};

export { GreffierMandataireStyle, GreffierCommentsStyle };
